import React from 'react';
import Modal, { ModalTransition } from '@atlaskit/modal-dialog';
import { updateShipToParty } from '@atlassian/temp-proxies';
import { UpdateBillToAndShipToParties } from '@atlassian/cssxp-types-billing';
import { useAddCustomerModal } from '@css-xp/base';
import { CreateCustomerWrapper } from './components/create-customer-wrapper';

export type AddCustomerModalProps = {
  isOpen?: boolean;
  onClose?: () => void;
};

export const AddCustomerStages = {
  CREATE_CUSTOMER: 'CREATE_CUSTOMER',
  CREATE_BILLING_PROFILE: 'CREATE_BILLING_PROFILE',
};

export const AddCustomerModal = ({ isSoldToAddressArchivalEnabled }: { isSoldToAddressArchivalEnabled?: boolean }) => {
  const {
    shouldAllowMultipleAddresses = false,
    shouldAllowCreatingBillingProfile = false,
    isAddCustomerModalOpen,
    closeAddCustomerModal,
    transactionAccountId,
    onSuccess,
  } = useAddCustomerModal();
  const [currentStage, setCurrentStage] = React.useState(AddCustomerStages.CREATE_CUSTOMER);
  const [showSuccessMessage, setShowSuccessMessage] = React.useState(false);
  const [showError, setShowError] = React.useState(false);
  const [isSubmitting, setIsSubmitting] = React.useState(false);

  const onClose = () => {
    closeAddCustomerModal();
    setShowSuccessMessage(false);
    setShowError(false);
  };

  const onSubmitCustomerStep = async (addresses: UpdateBillToAndShipToParties[] | UpdateBillToAndShipToParties) => {
    if (shouldAllowCreatingBillingProfile) {
      setCurrentStage(AddCustomerStages.CREATE_BILLING_PROFILE);
    } else {
      setIsSubmitting(true);
      const addressArray = shouldAllowMultipleAddresses
        ? (addresses as UpdateBillToAndShipToParties[])
        : ([addresses] as UpdateBillToAndShipToParties[]);

      const promises = addressArray.map((address) => {
        return updateShipToParty(address);
      });

      try {
        await Promise.all(promises);
        onSuccess && onSuccess();
        setShowSuccessMessage(true);
        setShowError(false);
      } catch (error) {
        setShowError(true);
        setShowSuccessMessage(false);
      }

      setIsSubmitting(false);
    }
  };

  return (
    <ModalTransition>
      {isAddCustomerModalOpen && (
        <Modal onClose={onClose} height="570px">
          {currentStage === AddCustomerStages.CREATE_CUSTOMER && (
            <CreateCustomerWrapper
              shouldAllowMultipleAddresses={shouldAllowMultipleAddresses}
              onClose={onClose}
              onSubmit={onSubmitCustomerStep}
              transactionAccountId={transactionAccountId}
              showSuccessMessage={showSuccessMessage}
              showErrorMessage={showError}
              isSubmitting={isSubmitting}
              isSoldToAddressArchivalEnabled={isSoldToAddressArchivalEnabled}
            />
          )}
        </Modal>
      )}
    </ModalTransition>
  );
};
